export default "__VITE_ASSET__CWCK_ca2__"